module.exports = __webpack_public_path__ + "img/homeOpenBg.cb0e4334.png";